import script from "./Offer.vue?vue&type=script&setup=true&lang=js"
export * from "./Offer.vue?vue&type=script&setup=true&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=7e02a2ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e02a2ef"]])

export default __exports__